/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Contract_TagInputs */

const vi_cdo_contract_tag = /** @type {(inputs: Cdo_Contract_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Giao hợp đồng)`)
};

/**

* @param {Cdo_Contract_TagInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_contract_tag = /** @type {((inputs?: Cdo_Contract_TagInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Contract_TagInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_contract_tag(inputs)
});